module.exports = __webpack_public_path__ + "media/images/crosswave-icon-2f88b9dd1b650a8397d8f06cb9e9368a.png";